var p = Object.defineProperty;
var u = (e, r, o) => r in e ? p(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o;
var l = (e, r, o) => u(e, typeof r != "symbol" ? r + "" : r, o);
import { COOKIE_SERVICE as m, LOGGER as d } from "@packages/common";
import { CONFIG as f } from "@packages/config";
import { Injectable as E, Inject as s } from "@webmotors/ioc";
import { USER_SERVICE as h } from "./main70.js";
var T = Object.getOwnPropertyDescriptor, b = (e, r, o, t) => {
  for (var a = t > 1 ? void 0 : t ? T(r, o) : r, n = e.length - 1, c; n >= 0; n--)
    (c = e[n]) && (a = c(a) || a);
  return a;
}, i = (e, r) => (o, t) => r(o, t, e);
let g = class {
  constructor(e, r, o) {
    l(this, "logger");
    this.cookie = e, this.loggerFactory = r, this.config = o, this.logger = this.loggerFactory.create(h);
  }
  /**
   * Safely decodes a Base64-URL encoded string.
   * @param encodedString - Base64-URL encoded string
   * @returns Decoded string
   */
  atob(e) {
    try {
      const r = e.replace(/-/g, "+").replace(/_/g, "/");
      return decodeURIComponent(
        atob(r).split("").map((o) => `%${o.charCodeAt(0).toString(16).padStart(2, "0")}`).join("")
      );
    } catch (r) {
      throw this.logger.error("[ATOB] Failed to decode base64 string", { error: r }), new Error("Failed to decode JWT.");
    }
  }
  /**
   * Parses the JWT string to retrieve the User.
   * @param encodedString - JWT token
   * @returns User object
   */
  parseJwtToken(e) {
    try {
      const r = e.split(".")[1];
      if (!r) throw new Error("Invalid JWT format.");
      const o = JSON.parse(this.atob(r)), t = {
        id: o["cognito:username"],
        name: o["custom:name_naturalperson"],
        email: o.email,
        phoneNumber: o.phone_number,
        authenticationToken: e
      };
      return this.logger.info("[GET] Parsed User: ", t), t;
    } catch (r) {
      throw this.logger.error("[Parse JWT] Failed to parse JWT", { error: r }), new Error("Unable to obtain user from JWT.");
    }
  }
  /**
   * Retrieves the current user from the JWT stored in cookies.
   * @returns User or null if not found.
   */
  getCurrentUser() {
    try {
      const e = this.cookie.get(
        this.config.authCookieName
      );
      return e ? this.parseJwtToken(e) : (this.logger.info("[GET] No user found in cookies."), null);
    } catch (e) {
      return this.logger.error("[GET] Failed to get user", e), null;
    }
  }
};
g = b([
  E(h),
  i(0, s(m)),
  i(1, s(d)),
  i(2, s(f))
], g);
export {
  g as UserService
};
